import { useRoot } from "../../contexts/Root";

export const Label = () => {
  const {
    theme: { foreground },
    label,
  } = useRoot();

  const style = {
    color: foreground,
  };

  return label !== undefined && <div style={style}>{label}</div>;
};
